import React from "react";
import AppBody from "../components/AppBody";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { getTrainerProfile } from "../../actions/trainer/trainer_profile_action";
import { useDispatch, useSelector } from "react-redux";

const TrainerProfile = () => {
  const dispatch = useDispatch("");
  const state = useSelector((state) => state.trainerProfileReducer);
  useEffect(() => {
    dispatch(getTrainerProfile());
  }, []);

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="">
            <div className="card">
              <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
                <Link
                  to={"/trainer/bank-details-list"}
                  className="d-inline-block mt-2"
                >
                  <i className="ti-arrow-left font-sm text-white"></i>
                </Link>
                <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                  Profile
                </h4>
                <div className="col text-right pr-0">
                  <Link to={"/trainer/update-profile"}>
                    <a
                      className="line-height-36 custom-icon mr-2"
                      title="Update Profile"
                    >
                      <i className="feather-edit"></i>
                    </a>
                  </Link>
                </div>
              </div>
              <div className="card-body  p-4 w-100 border-0 mt-2">
                <form>
                  <div className="row">
                    <div className="col-lg-4 mb-1"></div>
                    <div className="col-lg-4 mb-3">
                      <h1 className="mont-font fw-600 ">
                        {state.trainerDetails.first_name &&
                          state.trainerDetails.first_name +
                            " " +
                            state.trainerDetails.last_name}
                      </h1>
                      <img
                        className="img-circle" height={150} width={300}
                        src={
                          state.trainerDetails.profile_pic &&
                          state.trainerDetails.profile_pic
                        }
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-2 mb-1">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Name:
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-1">
                      <h1 className="mont-font fw-600 font-xsss">
                        {state.trainerDetails.first_name &&
                          state.trainerDetails.first_name +
                            " " +
                            state.trainerDetails.last_name}
                      </h1>
                    </div>
                    <div className="col-lg-2 mb-1">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Email:
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-3">
                      <label className="mont-font fw-600 font-xsss">
                        {state.trainerDetails.email &&
                          state.trainerDetails.email +
                            " " +
                            state.trainerDetails.email2}
                      </label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-2 mb-1">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Mobile No
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-1">
                      <label className="mont-font fw-600 font-xsss">
                        {state.trainerDetails.mobile_no &&
                          state.trainerDetails.mobile_no +
                            " " +
                            state.trainerDetails.mobile_no2}
                      </label>
                    </div>
                    <div className="col-lg-2 mb-1">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Base Location
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-3">
                      <label className="mont-font fw-600 font-xsss">
                        {state.trainerDetails.base_location &&
                          state.trainerDetails.base_location}
                      </label>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-2 mb-1">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Pan No
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-1">
                      <label className="mont-font fw-600 font-xsss">
                        {state.trainerDetails.pan_no &&
                          state.trainerDetails.pan_no}
                      </label>
                    </div>
                    <div className="col-lg-2 mb-1">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Aadhar No
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-3">
                      <label className="mont-font fw-600 font-xsss">
                        {state.trainerDetails.aadhar_no &&
                          state.trainerDetails.aadhar_no}
                      </label>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-2 mb-1">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Date of Birth
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-1">
                      <label className="mont-font fw-600 font-xsss">
                        {state.trainerDetails.dob && state.trainerDetails.dob}
                      </label>
                    </div>
                    <div className="col-lg-2 mb-1">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          GSTIN No
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-3">
                      <label className="mont-font fw-600 font-xsss">
                        {state.trainerDetails.GSTIN_no &&
                          state.trainerDetails.GSTIN_no}
                      </label>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-2 mb-1">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          State Code
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-1">
                      <label className="mont-font fw-600 font-xsss">
                        {state.trainerDetails.state_code &&
                          state.trainerDetails.state_code}
                      </label>
                    </div>
                    <div className="col-lg-2 mb-1">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          MSME Register No
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-3">
                      <label className="mont-font fw-600 font-xsss">
                        {state.trainerDetails.MSME_reg_no &&
                          state.trainerDetails.MSME_reg_no}
                      </label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-2 mb-1">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Type Of Enterprise
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-1">
                      <label className="mont-font fw-600 font-xsss">
                        {state.trainerDetails.type_of_enterprise &&
                          state.trainerDetails.type_of_enterprise}
                      </label>
                    </div>
                    <div className="col-lg-2 mb-1">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Category Of Services
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-3">
                      <label className="mont-font fw-600 font-xsss">
                        {state.trainerDetails.category_of_service &&
                          state.trainerDetails.category_of_service}
                      </label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-2 mb-1">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Type Of Enterprise
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-1">
                      <label className="mont-font fw-600 font-xsss">
                        {state.trainerDetails.type_of_enterprise &&
                          state.trainerDetails.type_of_enterprise}
                      </label>
                    </div>
                    <div className="col-lg-2 mb-1">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Category Of Services
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-3">
                      <label className="mont-font fw-600 font-xsss">
                        {state.trainerDetails.category_of_service &&
                          state.trainerDetails.category_of_service}
                      </label>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-2 mb-1">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Services Rendered
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-1">
                      <label className="mont-font fw-600 font-xsss">
                        {state.trainerDetails.services_rendered &&
                          state.trainerDetails.services_rendered}
                      </label>
                    </div>
                    <div className="col-lg-2 mb-1">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Experience Ovar All
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-3">
                      <label className="mont-font fw-600 font-xsss">
                        {state.trainerDetails.experience_over_all &&
                          state.trainerDetails.experience_over_all}
                      </label>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-2 mb-1">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Address:
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-1">
                      <label className="mont-font fw-600 font-xsss">
                        {state.trainerDetails.address &&
                          state.trainerDetails.address}
                      </label>
                    </div>
                      <div className="col-lg-4 mb-3">
                      <label className="mont-font fw-600 ">
                         Address Proof
                      </label>
                      <img
                        className="img-circle" height={150} width={300}
                        src={
                          state.trainerDetails.address_proof &&
                          state.trainerDetails.address_proof
                        }
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default TrainerProfile;
